<template>
    <div>
        <v-dialog persistent v-model="display" width="600">
            <v-card v-if="display == true">
                <v-toolbar dense color="primary" dark>
                    <v-row align="center" dark>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>Impostazione DNS</v-toolbar-title>
                        </v-col>
                        <v-col cols="2">
                            <v-btn small light @click="add">
                                <v-icon color="success">mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5" align="right">
                            <v-btn small light @click="save">
                                <v-icon color="success">mdi-check</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container :key="ui_key">
                    <v-row v-for="(dns,i) in dns_list" :key="i" align="center" dense>
                        <v-col cols="1">
                            <v-btn icon @click="moveup(i)">
                                <v-icon color="primary">mdi-arrow-up</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field :label="'DNS ' + (i+1)" :value="dns" @input="dns_list[i]=$event" />
                        </v-col>
                        <v-col cols="1" />
                        <v-col cols="2" align="right">
                            <v-btn small light @click="remove(i)">
                                <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import IpFormat from './ipformat.js';
export default {
    name : 'DialogDnsQuickConnext',
    data(){
        return{
            display : false,
            dns_list : null,
            ui_key : 0
        }
    },
    methods : {
        add(){
            this.dns_list.push('');
        },
        remove(index){
            this.dns_list.splice(index,1);
        },
        moveup(index){            
            if(index == 0){ return; }
            const previous = this.dns_list[index -1];
            const actual = this.dns_list[index];
            this.dns_list[index -1] = actual;
            this.dns_list[index] = previous;
            this.ui_key++;
        },
        open(dns_list){
            this.dns_list = dns_list;
            this.display = true;
        },
        save(){
            for(let i=0; i < this.dns_list.length; i++){
                if(!IpFormat.checkIpFormat(this.dns_list[i])){
                    alert('Il DNS '+ (i+1) + ' ha un formato non corretto');
                    return;
                }
            }
            this.display = false;
        }
    }
}
</script>